const ru = {
  'Language Key': 'ru',
  'cui-org-info': 'Информация об организации',
  'cui-sign-on-info': 'Вход на информацию',
  'cui-user-info': 'Информация о пользователе',
  'cui-preferences': 'предпочтения',
  'cui-review': 'Обзор',
  'cui-org': 'организация',
  'cui-company-division': 'Компания / Отдел',
  'cui-org-address': 'Адрес организации',
  'cui-user-address': 'Пользователь Адрес',
  'cui-country': 'Страна',
  'cui-city': 'город',
  'cui-state': 'Штат / провинция',
  'cui-postal': 'Почтовый индекс',
  'cui-user-id': 'Идентификатор пользователя',
  'cui-password': 'пароль',
  'cui-password-re': 'Повторно введите пароль',
  'cui-challenge-question': 'Проблемный вопрос',
  'cui-challenge-answer': 'Вызова ответ',
  'cui-favorite-pet-q': 'Как зовут ваше любимое домашнее животное?',
  'cui-mother-q': 'Что девичья фамилия вашей матери?',
  'cui-best-friend-q': 'Кто твой лучший друг?',
  'cui-first-name': 'Имя',
  'cui-last-name': 'Фамилия',
  'cui-email': 'Эл. адрес',
  'cui-email-re': 'Повторно введите адрес электронной почты',
  'cui-telephone': 'Номер телефона',
  'cui-timezone': 'Часовой пояс',
  'cui-submit': 'ОТПРАВИТЬ',
  'cui-next': 'СЛЕДУЮЩИЙ ШАГ',
  'cui-previous': 'ПРЕДЫДУЩИЙ',
  'cui-create-security-admin-account': 'Создание учетной записи администратора безопасности',
  'cui-skip-for-now': 'ПРОПУСТИТЬ СЕЙЧАС',
  'icon-library': 'Icon Library',
  'cui-new-TLO': 'Новая организация верхнего уровня',
  'cui-new-TLO-description': 'Выберите этот метод, если вы хотите присоединиться к Covisint биржи в качестве новой организации Covisint',
  'cui-new-division': 'Новый Отдел',
  'cui-new-division-description-start': 'Выберите этот метод, если вы хотите стать',
  'cui-new-division-description-end': 'новый отдел в рамках существующей Covisint организации.',
  'cui-security-administrator': 'Администратор безопасности',
  'cui-new-user': 'Новый пользователь',
  'cui-new-user-description': 'Выберите этот метод, если вы являетесь сотрудником существующего Covisint члена общества, стремящимся получить доступ к приложению вашей организации при подписке или если вы не уверены, что ваша организация зарегистрирована.',
  'cui-sign-up': 'Зарегистрироваться',
  'cui-address': 'Адрес',
  'cui-organization-name': 'Компания / Отдел',
  'cui-supplier-code': 'Код поставщиком',
  'cui-address-1': 'адрес 1',
  'cui-address-2': 'Адрес 2',
  'cui-user-information': 'информация о пользователе',
  'cui-organization-information': 'информация об организации',
  'cui-sign-in-information': 'Вход Информация',
  'cui-package-selection': 'Выбранный пакет',
  'cui-welcome-popover': 'В обязанности администратора безопасности будут подробно объяснены после выбора метода регистрации. Тем не менее, вы можете отменить регистрацию, чтобы позволить другой член вашей Organiziation регистрации в качестве администратора безопасности.',
  'create-account': 'Создать аккаунт',
  'cui-agree-covisint': 'Я согласен с Covisint',
  'terms-of-service': 'Условия использования',
  'cui-and': 'а также',
  'privacy-policy': 'политика конфиденциальности',
  'cui-tos-agree': 'Вы должны согласиться с Условиями предоставления услуг, чтобы продолжить.',
  'cui-user-profile': 'Профиль пользователя',
  'cui-my-profile': 'Мой профайл',
  'cui-login': 'Авторизоваться',
  'cui-supplier-content': 'Обновление это после того, как дизайн документы приходят. Это в переводе Google док. Lorem Ipsum. Другие вещи. Код поставщика важной информации. Мне нравятся черепахи.',
  'cui-all-organizations': 'Все организации:',
  'cui-application-select-info': 'Вы всегда можете сделать свой выбор после входа в систему в первый раз.',
  'cui-all-applications': 'Все приложения',
  'cui-page-not-found': 'Страница не найдена',
  'cui-page-not-found-content': 'Страница, которую вы ищете не может быть удалена или никогда не существовали.',
  'cui-home': 'ГЛАВНАЯ',
  'cui-access-denied': 'Доступ закрыт',
  'cui-access-denied-content': 'Вы не авторизованы для просмотра этой страницы.',
  'cui-registration-status': 'Состояние регистрации',
  'cui-pending-status': 'В ожидании статуса',
  'cui-pending-status-content': 'Ваш статус регистрации еще не завершен. Вы получите письмо с подробной информацией в ближайшее время.',
  'cui-thank-you': 'спасибо',
  'cui-request-submitted': 'Запрос Представлено',
  'cui-success': 'успех',
  'cui-success-content': 'Ваша регистрация Covisint была успешно отправлена. Вы получите письмо с подробной информацией в ближайшее время.',
  'cui-check-your': 'Проверьте свои',
  'cui-registration-status-lower': 'статус регистрации',
  'cui-application-selection': 'Выбор приложения',
  'cui-applications': 'Приложения',
  'cui-profile-settings': 'Настройки профиля',
  'cui-name': 'имя',
  'cui-update': 'Обновить',
  'cui-updated': 'обновленный',
  'cui-error-try-again': 'Ошибка! Попробуй еще раз?',
  'cui-back': 'назад',
  'cui-selections': 'Выбор',
  'cui-add-org': 'Добавить организацию',
  'cui-remove-org': 'Удалить Организацию',
  'cui-select-org': 'Выберите Организацию',
  'cui-more-information': 'Больше информации',
  'cui-inv-user-popover-info': 'По соображениям безопасности, вы должны зарегистрироваться в электронной почте Ваше приглашение было отправлено. Это может быть изменено в настройках пользователя при завершении регистрации.',
  'cui-org-profile': 'Профиль организации',
  'cui-info': 'Информация',
  'cui-admins': 'Админы',
  'lowercase-not-allowed': 'не имеют каких-либо строчные буквы',
  'uppercase-not-allowed': 'не имеют каких-либо заглавные буквы',
  'numbers-not-allowed': 'нет номера',
  'special-not-allowed': 'не имеют каких-либо специальных символов (например:! * +)',
  'chars-not-allowed': 'не включают какой-либо из следующих символов: {{disallowedChars}}',
  'words-not-allowed': 'не включают какое-либо из следующих слов: {{disallowedWords}}',
  'password-length': 'состоят из {{min}}-{{max}} символов',
  'password-rules': 'включают {{requiredNumberOfCharClasses}} из следующих условий:',
  'password-lowercase': 'по меньшей мере, 1 строчная буква',
  'password-uppercase': 'по меньшей мере, 1 прописная буква',
  'password-number': 'по меньшей мере, один номер',
  'password-special': 'по меньшей мере, один специальный символ (например:! * +)',
  'passwords-must': 'Пароли должны:',
  'welcome-title': 'Регистрация для одного из следующих',
  'cui-application-name': 'Имя приложения',
  'cui-application-tos': 'Обзор Правила и условия',
  'cui-application-tos-agreement': 'Правила и условия соглашения',
  'cui-package-tos': 'Вы не приняли условия для пакетов, выбранных.',
  'cui-view-tos': 'Просмотреть Правила и условия',
  'password-mismatch': 'Пароли должны совпадать',
  'cui-back-to-review': 'Вернуться к просмотру',
  'email-mismatch': 'Письма должны соответствовать',
  'no-applications-selected': 'У вас нет каких-либо приложений, выбранных. Нажмите здесь, чтобы вернуться к выбору приложений.',
  'cui-all-fields-required': 'Все поля обязательны для заполнения',
  'cui-complete-registration': 'Завершите регистрацию ниже с',
  'cui-registered': 'зарегистрированный',
  'cui-open': 'открыто',
  'cui-close': 'Закрыть',
  'cui-street-address': 'Адрес улицы',
  'cui-zip': 'застежка-молния',
  'cui-language': 'язык',
  'cui-phone-main': 'Главный',
  'cui-phone-office': 'офис',
  'cui-phone-fax': 'Телефон / Факс',
  'cui-phone-mobile': 'мобильный',
  'cui-save': 'Сохранить',
  'cui-cancel': 'Отмена',
  'cui-edit': 'редактировать',
  'cui-phone': 'Телефон',
  'search-by-app-name': 'Поиск по названию приложения',
  'new-request': 'Новый запрос',
  'select-applications': 'Выберите Приложения',
  'browse-applications': 'Обзор приложений',
  'go': 'Идти',
  'filter-list': 'Список фильтров',
  'filter': 'Фильтр',
  'owning-org': 'Обладание Org',
  'my-applications': 'Мои приложения',
  'app-summary': 'App Резюме',
  'granted': 'Предоставляется',
  'bundled-applications': 'Другие применения',
  'application-details': 'Нанесение',
  'my-claims': 'Мои претензии',
  'related-applications': 'Родственные заявки',
  'review-request': 'Запрос Обзор',
  'back-to-search': 'Вернуться к поиску',
  'requested-items': 'Запрашиваемые товары',
  'request-reason': 'Запрос Reason',
  'reason-im-requesting': 'Причина я запрашивающий',
  'you-must-enter-a-reason': 'Вы должны указать причину, чтобы просить это приложение',
  'cui-org-no-applications': 'Похоже, ваша организация не имеет каких-либо приложений. Вы всегда можете попробовать еще раз после входа в систему.',
  'cui-filter-org-name': 'Фильтр по названию организации',
  'cui-address-example': 'Квартира корпус дом. (необязательный)',
  'cui-filter-app-name': 'Фильтр по имени приложения',
  'cui-search-user-name': 'Поиск пользователей по имени',
  'page': 'страница',
  'cui-num-results-page': 'Результатов на странице',
  'submit-request': 'Отправить запрос',
  'categories': 'категории',
  'cui-answer': 'Ответ',
  'cui-enter-password': 'Введите пароль',
  'cui-enter-new-password': 'Введите новый пароль',
  'cui-re-enter-new-password': 'Повторно введите новый пароль',
  'granted-to-my-org': 'Предоставленный моей организации',
  'collected-items-for-request': 'Собираемые товары для запроса',
  'cui-invalid-password': 'Неверный пароль. Пожалуйста, попробуйте еще раз.',
  'cui-faq': 'Вопросы-Ответы',
  'cui-frequently-asked-questions': 'Часто задаваемые вопросы',
  'cui-admin-tools': 'Инструменты администратора',
  'cui-this-field-is-required': 'Это поле обязательно к заполнению.',
  'cui-this-field-needs-to-be-longer': 'Это поле должно быть больше.',
  'cui-you-need-to-agree-to-toc': 'Вы должны согласиться с Условиями предоставления услуг, прежде чем продолжить.',
  'cui-this-is-not-valid-email': 'Это не действительный адрес электронной почты.',
  'cui-my-app-requests': 'Мои запросы приложений',
  'cui-no-claims': 'У вас нет претензий к этой заявке.',
  'cui-no-details': 'Нет данных доступны.',
  'request': 'Запрос',
  'all': 'Все',
  'no-selected-apps': 'Вы не выбрали ни одной заявки.',
  'basic-info': 'Основная информация',
  'cui-error-username-exists': 'Идентификатор пользователя уже существует! Пожалуйста, выберите другой.',
  'password-reset': 'Восстановление пароля',
  'current-password': 'текущий пароль',
  'timezone-and-language': 'Timezone и язык',
  'challenge-questions': 'Вызов Вопросы',
  'security-question-repeated': 'Ответ на этот вопрос уже был использован.',
  'cui-by-date-added': 'Дата Добавлена',
  'cui-alphabetically': 'По алфавиту',
  'active': 'активный',
  'pending': 'в ожидании',
  'suspended': 'подвешенный',
  'title': 'заглавие',
  'id': 'Я БЫ',
  'url': 'Веб-сайт',
  'privacy-terms': 'Защита & Условия',
  'help': 'Помогите',
  'cui-learn-more-start': 'Выучить больше',
  'cui-learn-more-end': 'о том, почему мы задаем эту информацию',
  'cui-org-hierarchy': 'Иерархия организации',
  'directory': 'каталог',
  'userID': 'Идентификатор пользователя',
  'status': 'Положение дел',
  'locked': 'запертый',
  'rejected': 'Отклонено',
  'removed': 'Удалены',
  'sort': 'Сортировать',
  'refine': 'усовершенствовать',
  'or': 'Или',
  'organizations': 'организации',
  'roles': 'Роли',
  'organization-applications': 'Организация применения',
  'unactivated': 'неактивированной',
  'log-out': 'Выйти',
  'welcome': 'желанный',
  'privacy': 'Конфиденциальность',
  'terms': 'сроки',
  'user': 'пользователь',
  'top-level-orgs': 'Лучшие организации Уровень',
  'invite-user': 'Пригласить пользователя',
  'invite-division': 'Пригласить Отдел',
  'username': 'имя пользователя',
  'move': 'переехать',
  'no-bundled-or-related': 'Нет в комплекте или связанные приложения.',
  'cui-continue': 'Продолжать',
  'cui-no-org-divisions': 'Нет организации подразделения',
  'inactive': 'Неактивный',
  'deny': 'Отрицать',
  'approve': 'Одобрить',
  'pending-request': 'В ожидании запроса',
  'review-approvals': 'Обзор Сертификаты',
  'cui-package-no-claims': 'Этот пакет не содержит никаких претензий',
  'claims': 'требования',
  'package-name': 'Имя пакета',
  'submit-approvals': 'Отправить Одобрение',
  'view-details': 'Посмотреть детали',
  'request-date': 'Дата заказа',
  'registration-decision': 'Регистрация Решение',
  'requested': 'запрошенный',
  'getting-user-info': 'Получение информации о пользователе ...',
  'approvals-submitted': 'Допуски Представлено',
  'rejection-submitted': 'Отторжение Представлено',
  'approval-summary': 'Резюме Утверждение',
  'approved-items': 'Одобренные товары',
  'rejected-items': 'Забракованные товары',
  'registration-request-approved': 'Запрос Утверждена регистрация',
  'registration-request-rejected': 'Запрос Отклонено регистрация',
  'no-items-rejected': 'Нет ничего отвергнуто',
  'no-items-approved': 'не утвержден Нет',
  'registration-request': 'регистрации',
  'custom-api-loading': 'Инициализация приложения ...',
  'new-grant': 'приложение',
  'search-by-package-name': 'Поиск по названию пакета',
  'search': 'Поиск',
  'administartor-?': 'Администратор?',
  'submit-grant-update': 'Отправить обновление гранта',
  'review-user-pending-approval': 'Отзывы пользователей В ожидании одобрения',
  'view-request-for': 'Посмотреть Запрос',
  'job-title': 'Название работы',
  'query': 'запрос',
  'suspend-app': 'Приостановка приложения',
  'new-grants': 'Новые гранты',
  'update-grant-settings': 'Настройки Grant Update',
  'assign-new-grant-to': 'Назначают новый грант',
  'division': 'разделение',
  'redirecting-to-sso': 'Запрос учетных данных',
  'included-applications': 'Входящие в комплект приложений',
  'selected-sub-packages': 'Отдельный Суб-пакеты',
  'specify-password': 'Укажите пароль',
  'suspend': 'приостановить',
  'reset-password': 'Сброс пароля',
  'confirm-password-reset': 'Вы уверены, что хотите сбросить пароль для этого пользователя?',
  'yes': 'да',
  'within': 'в',
  'search-within': 'Искать в',
  'in-your-org': 'в вашем орге',
  'people': 'люди',
  'revoke-package': 'Отозвать пакет',
  'cui-by-username': 'имя пользователя',
  'cui-by-status': 'Положение дел',
  'cool-got-it': 'Круто, получил его',
  'organization-directory': 'Справочник организации',
  'org-nav-invite-links': 'Организация навигации и пригласительные ссылки',
  'org-dir-filters': 'Справочник организации Фильтры',
  'org-dir-list': 'Организация списка каталогов',
  'apps': 'Программы',
  'apps-upper': 'ПРОГРАММЫ',
  'history-upper': 'ИСТОРИЯ',
  'profile-upper': 'ПРОФИЛЬ',
  'roles-upper': 'РОЛИ',
  'your-app-request-in-review': 'Ваш запрос на заявление подано',
  'error-generic': 'Был вопрос загрузки данных на этой странице. Пожалуйста, попробуйте еще раз.',
  'cui-application-administrator': 'в настоящее время не имеет роли администратора приложений, которые должны быть назначены до того, как пользователь может получить права администрирования для данного приложения. Это одна установка времени.',
  'cui-assign-confirm': 'Вы хотите присвоить эту роль сейчас?',
  'cui-suspend-warning': 'будет не в состоянии открыть приложение',
  'cui-suspend-confirm': 'Вы уверены, что вы хотите, чтобы приостановить сейчас?',
  'cui-notify-user': 'Уведомить пользователя',
  'cui-users': 'пользователей',
  'cui-no': 'нет',
  'cui-remove': 'Удалены',
  'cui-org-abbrev': 'организация',
  'cui-userProfile-user-error': 'Была ошибка при получении данных пользователя. Пожалуйста, попробуйте еще раз.',
  'cui-userProfile-security-error': 'Была ошибка при получении данных вопроса безопасности. Пожалуйста, попробуйте еще раз.',
  'cui-userProfile-password-error': 'Была ошибка при получении данных политики паролей. Пожалуйста, попробуйте еще раз.',
  'cui-suspend-success': 'Это приложение в настоящее время отстранено от выбранного пользователя',
  'cui-unlock': 'отпереть',
  'cui-unlock-password-confirm': 'Вы уверены, что вы хотели бы, чтобы разблокировать пароль этого пользователя?',
  'cui-error-unlocking-password': 'К сожалению, произошла ошибка разблокировки пароля этого пользователя.',
  'cui-error-person-request': 'Невозможно получить данные запроса регистрации для этого пользователя.',
  'cui-error-email-exists': 'Адрес электронной почты уже принято',
  'cui-password-history-rule': 'не соответствуют ни одному из предыдущих {{}} numberOfPasswords паролей',
  'cui-password-policy': 'Политика паролей',
  'cui-security-admin': 'Администраторы безопасности',
  'cui-button-loading-text': 'Loading ...',
  'cui-username-taken': 'Имя пользователя принимается',
  'cui-no-applications': 'Вы в настоящее время нет приложений',
  'cui-mask-answers': 'Маска ответы безопасности / разоблачать',
  'cui-pwd-reset-success': 'Сброс пароля успеха!',
  'cui-last-login': 'Последний Войти',
  'cui-need-different-app': 'Нужен другое приложение',
  'cui-go-back-to': 'Вернуться к',
  'cui-tos-applications': 'Пожалуйста, примите Условия & Условия для выбранных приложений',
  'cui-selected-apps': 'Выбранные приложения',
  'cui-authentication-policy': 'Политика аутентификации',
  'cui-selected': 'выбранный',
  'cui-tac': 'Условия и положения',
  'cui-accept': 'принимать',
  'cui-tac-agree': 'Вы должны согласиться с Условиями, чтобы продолжить.',
  'cui-printer-friendly-tac': 'Версия для печати Правила и условия',
  'cui-my-history': 'Моя история',
  'cui-status-history': 'Моя история Статус',
  'cui-app-history': 'История применения',
  'cui-password-change-log': 'журнал изменений пароля',
  'cui-date': 'Дата',
  'cui-event-type': 'Тип события',
  'cui-action-by': 'Действие Исполняет',
  'cui-notes': 'Заметки',
  'cui-try-again': 'Пожалуйста, попробуйте еще раз.',
  'cui-password-change-log-error': 'Был журнал изменений пароля ошибки при получении.',
  'cui-userstatus-history-error': 'Была ошибку при получении истории статуса пользователя.',
  'cui-claims-error': 'Была ошибка при получении претензий.',
  'cui-org-app-suspend-success': 'Это приложение в настоящее время приостановлено из выбранных организаций, всех пользователей и всех подразделений.',
  'cui-org-app-suspend-msg1': 'Это действие, когда в активном использовании приостанавливает действие от всех пользователей и подразделов организаций даже.',
  'cui-org-app-suspend-msg2': 'Вы уверены, что хотите приостановить',
  'cui-from': 'из',
  'cui-application-granted-history': 'Применение История Грант',
  'cui-application-requested-history': 'Применение Запрос История',
  'approved': 'утвержденный',
  'decision': 'Решение',
  'evaluator': 'оценщик',
  'action': 'действие',
  'cui-invalid-invitation': 'Приглашение либо уже используется или Invalid',
  'cui-by-request-date': 'Дата заказа',
  'cui-by-decision-date': 'Решение Дата',
  'cui-no-orgs-for-name': 'Не найдено для указанного имени организации. Пожалуйста, попробуйте с другим именем.',
  'requests': 'Запросы',
  'no-pending-apps': 'У вас нет ожидающих запросов приложений.',
  'description': 'Описание',
  'launch': 'запуск',
  'manage-applications': 'Управление приложениями',
  'request-type': 'тип запроса',
  'phase': 'фаза',
  'date-submitted': 'Дата представления',
  'cui-pending-requests-error': 'Была ошибка при извлечении / обновлении запросов.',
  'no-requests-by-name': 'не прошу не найдено для указанного имени. Пожалуйста, попробуйте с другим именем.',
  'cannot-change-password': 'Невозможно изменить пароль прямо сейчас',
  'select-claims': 'Выберите Иски',
  'grant-reason': 'Грант Reason',
  'grants-assigned': 'Новые гранты Assigned',
  'suspend-error': 'Была ошибка в спящих запросы.',
  'unsuspend-error': 'Была ошибка в запросах разблокировать.',
  'approval': 'утверждение',
  'administrator': 'администратор',
  'submitted': 'Отправлено',
  'no-bundled': 'Нет в комплекте приложений',
  'disallowed-password-rule': 'Не могу содержать слово на запрещенный список слов',
  'request-approve-or-rejected': 'Этот запрос либо Утвержденная / Отклонено',
  'application': 'заявка',
  'show-all': 'Показать все',
  'cui-subject': 'Предмет',
  'cui-es': '(А)',
  'cui-invite-user': 'Пригласить пользователь в рамках',
  'cui-invite-user-success': 'Ваш запрос пользователя приглашение отправлено',
  'cui-email-recipt': 'Введите адрес электронной почты получателя (разделяйте запятыми)',
  'cui-invite-verbiage': 'Приглашение для одного из следующих',
  'select': 'Выбрать',
  'change-org': 'Изменение Org',
  'cui-invite-user-sub': 'Зарегистрироваться как пользователь, чтобы присоединиться',
  'cui-invite-user-select': 'Поиск для орга',
  'cui-send-invitation': 'Выслать пригласительное',
  'invite': 'приглашение',
  'cui-invite-tlo-success': 'Ваш верхний уровень запроса организации приглашение отправлено',
  'cui-invite-tlo': 'Пригласить новую организацию',
  'cui-invite-division-success': 'Ваш запрос компании приглашение отправлено',
  'cui-invite-division': 'Пригласите организации',
  'cui-tlo-sub': 'Регистрация в качестве новой организации',
  'cui-division-sub': 'Регистрация как в, администратором',
  'search-by-org-name': 'Поиск по названию организации',
  'app-approval-error': 'Была ошибка в утверждении App запросов.',
  'modify-claims': 'Изменение формулы изобретения',
  'unsuspend-app': 'App разблокировать',
  'remove-app': 'Удалить приложение',
  'user-details': 'Сведения о пользователе',
  'reason': 'причина',
  'required': 'необходимые',
  'cui-unsuspend-confirm': 'Вы уверены, что вы хотите, чтобы разблокировать сейчас?',
  'unsuspend': 'Разблокировать',
  'remove-confirm': 'Вы уверены, что хотите удалить сейчас?',
  'remove': 'Удалить',
  'my-organization': 'Моя организация',
  'request-app': 'Запрос App',
  'no-apps-found': 'Никакие приложения не найдено.',
  'refine-search': 'Пожалуйста, уточните критерии поиска.',
  'your-assign-role-success': 'Новая роль Назначенный',
  'cui-assigned-roles': 'Назначенные роли',
  'cui-available-roles': 'Доступные роли',
  'cui-browse-by-category': 'Просмотр по категориям',
  'cui-back-navigation-requests': 'Назад навигации и запросы',
  'cui-search-results': 'результаты поиска',
  'cui-new-grant-search-results': 'Новый грант Результаты поиска',
  'cui-username-close': 'Имя пользователя и близко навигации',
  'cui-user-no-apps': 'Пользователь не имеет приложений',
  'cui-no-roles-assigned': 'Этот пользователь не имеет назначенных ролей.',
  'status-history': 'История Статус',
  'cui-no-status-history': 'Этот пользователь не имеет истории статуса.',
  'cui-pwd-reset-msg1': 'Сброс пароля успешно. Новый пароль:',
  'cui-pwd-reset-msg2': 'Примечание: если вы видите только первую половину пароль, то вторая половина пароля будет отправлена ​​пользователям, зарегистрированным по электронной почте.',
  'users-upper': 'ПОЛЬЗОВАТЕЛИ',
  'hierarchy-upper': 'ИЕРАРХИЯ',
  'privileges': 'привилегии',
  'expand-all': 'Расширить все',
  'collapse-all': 'Свернуть все',
  'no-records': 'Записей не найдено.',
  'contact-us': 'Свяжитесь с нами',
  'cui-error-organization-request': 'Невозможно получить данные запроса регистрации для данной организации.',
  'cui-error-organization-app-request': 'Невозможно получить данные запроса приложения для этой организации',
  'cui-error-user-app-request': 'Невозможно получить данные запроса приложения для этого пользователя',
  'assign': 'приписывать',
  'search-by-person-name': 'Поиск по имени человека',
  'grant-history': 'История Грант',
  'request-history': 'Запрос истории',
  'social-login': 'Социальный Войти',
  'facebook': 'facebook',
  'twitter': 'щебет',
  'link': 'Ссылка',
  'unlink': 'Unlink',
  'invalid-url': 'Это не является допустимой URL.',
  'linkedin': 'LinkedIn',
  'google': 'Google',
  'administration': 'администрация',
  'services': 'Сервисы',
  'n-phase': 'N - этап Утверждение',
  'edit-package': 'Изменить пакет',
  'is-requestable': 'Является ли запрошены',
  'is-displayable': 'Есть Отображаемые',
  'is-grantable': 'Есть выдаваемые',
  'require': 'требовать',
  'is-requestable-desc': 'Укажите, если пользователь может запросить это приложение.',
  'is-grantable-desc': 'Укажите, если это приложение может быть предоставлено непосредственно администрацией компании к пользователю',
  'is-displayable-desc': 'Укажите, если значок пакет должен отображаться на странице Мои Приложения',
  'require-reason-desc': 'Укажите, если этот пакет требуется пользователю указать причину запроса этот пакет',
  'company-admin': 'Компания Администратор',
  'application-admin': 'Применение администратора',
  'company-admin-desc': 'Это фаза утверждения по умолчанию, она должна быть Да, если нет другой фазы требуется',
  'application-admin-desc': 'Есть ли приложение пользователю необходимо запрос должен быть одобрен администратором приложения?',
  'add-admins': 'Добавить Администратор',
  'cardinality-indicator': 'Cardinality Индикатор',
  'cui-one': 'Один',
  'cui-many': 'Многие',
  'claim-values': 'Претензия Значения',
  'cui-add': 'Добавить',
  'cui-view': 'Посмотреть',
  'cui-claim': 'Запрос',
  'cui-category': 'категория',
  'cui-service': 'обслуживание',
  'cui-delete': 'Удалить',
  'federation-conn': 'Федерация соединения',
  'updated-date': 'Обновлено Дата',
  'target-url': 'URL целевой',
  'remote-app-id': 'Удаленная идентификация приложений',
  'mobile-sso-url': 'Мобильный URL-ССО',
  'mobile-app-id': 'Идентификатор мобильного приложения',
  'cui-package': 'пакет',
  'cui-create': 'Создайте',
  'more-languages': 'Другие Языки',
  'duplicate-language-error': 'Повторяющиеся языки не допускаются',
  'cui-nextstep': 'следующий',
  'create-package': 'Создать пакет',
  'manage-package-claims': 'Управление Пакет Требований',
  'cardinality-indicator-error': 'Cardinality Индикатор не может быть один',
  'value-id-exists': 'Значение Id уже существует',
  'claim-id-exists': 'Id претензии уже существует',
  'cui-new': 'новый',
  'package-success-content': 'Пакет успешно создан',
  'add-claims': 'Добавить Требования',
  'package-update-success': 'Пакет успешно обновлен'

}

export {
  ru
}



// WEBPACK FOOTER //
// ./src/plugins/i18n/ru.js